module.exports = __webpack_public_path__ + "img/fogg-no-comments.a36c092c.svg";